import { render, staticRenderFns } from "./servicePeriod.vue?vue&type=template&id=b374d5f2&scoped=true"
import script from "./servicePeriod.vue?vue&type=script&lang=js"
export * from "./servicePeriod.vue?vue&type=script&lang=js"
import style0 from "./servicePeriod.vue?vue&type=style&index=0&id=b374d5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b374d5f2",
  null
  
)

export default component.exports